import React from "react";
import Radium from "radium";
import moment from "moment-timezone";
import { FlatButton, IconButton } from "material-ui";
import BackIcon from "material-ui/svg-icons/navigation/arrow-back";
import ForwardIcon from "material-ui/svg-icons/navigation/arrow-forward"
const _Button = Radium(FlatButton);

const DateButtons = (
  { selectedDate, dates, onDateSelected, forceSmall, rawDate, inline, isYearRound, dateParam },
  { muiTheme, tenant }
) => {
  const buttonColor = muiTheme.rawTheme.palette.accent1Color,
    buttonTextColor = tenant.invert_colors ? "rgb(33,33,33)" : "#fff";

  const onNextWeekClick = () => {
    onDateSelected(moment(dates[0]).add(7, "days").format("YYYY-MM-DD"));
  }

  const onPreviousWeekClick = () => {
    const newDate = moment(dates[0]).add(-7, "days")

    if (newDate.startOf("day").isBefore(moment().startOf("day"))) {
      onDateSelected(moment().format("YYYY-MM-DD"));
    } else {
      onDateSelected(newDate.format("YYYY-MM-DD"));
    }
  }


  return (
    <div
      style={[
        styles.dateButtonContainer,
        forceSmall && styles.smallDateButtonContainer,
        inline && styles.inlineDateButtonContainer
      ]}
    >
      {isYearRound && !moment(dates[0]).startOf("day").isSame(moment().startOf("day")) &&
        <div style={[
          styles.weekButtonWrapper
        ]}>
          <IconButton
            style={styles.prevWeekButton}
            iconStyle={styles.weekNavigationIcon}
            onClick={onPreviousWeekClick}
          >
            <BackIcon />
          </IconButton>
        </div>
      }
      {dates.map(d => {
        const m = moment(d);
        return (
          <div
            key={d}
            style={[
              styles.dateButtonWrapper,
              forceSmall && styles.smallDateButtonWrapper
            ]}
          >
            <_Button
              style={Object.assign(
                {},
                styles.dateButton,
                selectedDate.isSame(d) && {
                  backgroundColor: buttonColor,
                  color: buttonTextColor,
                  border: `1px solid ${buttonColor}`
                }
              )}
              labelStyle={{ verticalAlign: 0 }}
              label={
                <div>
                  {!forceSmall && (
                    <div style={styles.dateInner}>
                      <div style={styles.dateDay}>{m.format("dddd")}</div>
                      <div style={styles.dateDate}>{m.format("MMM Do")}</div>
                    </div>
                  )}
                  <div
                    style={[
                      styles.dateInnerSmall,
                      forceSmall && styles.forcedDateInnerSmall
                    ]}
                  >
                    {m.format("ddd MMM D")}
                  </div>
                </div>
              }
              onClick={() =>
                onDateSelected(rawDate ? m : m.format("YYYY-MM-DD"))
              }
            />
          </div>
        );
      })}
      {isYearRound &&
        <div style={[styles.weekButtonWrapper]}>
          <IconButton
            style={Object.assign(

              {},
              styles.nextWeekButton,
            )}
            onClick={onNextWeekClick}
            iconStyle={styles.weekNavigationIcon}
          >
            <ForwardIcon />
          </IconButton>
        </div>
      }
    </div>
  );
};

DateButtons.contextTypes = {
  muiTheme: React.PropTypes.object,
  tenant: React.PropTypes.object
};

const styles = {
  dateButtonContainer: {
    fontSize: "13px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginLeft: "-0.5em",
    width: "calc(100% + 1em)",
    marginBottom: "1em",
    justifyContent: "center",
    "@media (max-width: 600px)": {
      marginLeft: 0,
      marginRight: 0,
      width: "calc(100% - 0.3em)"
    }
  },
  smallDateButtonContainer: {
    marginLeft: 0,
    marginRight: 0,
    width: "100%"
  },
  inlineDateButtonContainer: {
    justifyContent: "initial",
    marginLeft: "-0.3em",
    marginRight: "-0.3em",
    marginTop: "-0.3em",
    marginBottom: "-0.3em",
    "@media (max-width: 600px)": {
      marginLeft: "-0.3em",
      marginRight: "-0.3em",
      width: "100%"
    }
  },
  dateButtonWrapper: {
    margin: "0.3em",
    width: "100%",
    flexBasis: 115,
    maxWidth: 115,
    height: 50,
    "@media (max-width: 600px)": {
      display: "inline-block",
      flexBasis: 85,
      height: 30
    }
  },
  weekButtonWrapper: {
    margin: "0.3em",
    width: "100%",
    flexBasis: 45,
    maxWidth: 45,
    height: 45,
    alignSelf: "center",
    "@media (max-width: 600px)": {
      display: "inline-block",
      flexBasis: 85,
      height: 30
    }
  },
  smallDateButtonWrapper: {
    display: "inline-block",
    flexBasis: 85,
    height: 30
  },
  dateButton: {
    border: "1px solid",
    width: "100%",
    height: "100%"
  },
  nextWeekButton: {
    width: "100%",
    height: "100%",
  },
  prevWeekButton: {
    width: "100%",
    height: "100%"
  },
  weekNavigationIcon: {
    width: 20,
    height: 20,
  },
  dateInner: {
    marginTop: -27,
    lineHeight: 1.3,
    fontSize: "10pt",
    display: "block",
    "@media (max-width: 600px)": {
      display: "none"
    }
  },
  dateInnerSmall: {
    display: "none",
    fontSize: "9pt",
    marginTop: -39,
    "@media (max-width: 600px)": {
      display: "block"
    }
  },
  forcedDateInnerSmall: {
    display: "block"
  },
  dateDay: {
    fontSize: "0.9em"
  }
};

export default Radium(DateButtons);



// WEBPACK FOOTER //
// ./src/app/components/partials/marquee/date-buttons.jsx